import { Dictionary } from "@insite/client-framework/Common/Types";
import { ApiHandlerDiscreteParameter, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { doesNotHaveExpand, get } from "@insite/client-framework/Services/ApiService";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Accounts/Handlers/LoadAccount";
import { AccountModel, BaseModel, WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import { StoreGetAccountApiParameter } from "@store/Types/ApiModels";

export interface StoreAccountModel extends BaseModel {
    accessToken: string;
    activationStatus: string;
    approver: string;
    availableApprovers?: string[] | null;
    availableRoles?: string[] | null;
    availableRolesTranslated: { [key: string]: string } | null;
    billToId: string | null;
    canApproveOrders: boolean;
    canViewApprovalOrders: boolean;
    defaultCustomerId: string | null;
    defaultFulfillmentMethod: string;
    defaultWarehouse: WarehouseModel | null;
    defaultWarehouseId: string | null;
    email: string;
    firstName: string;
    id: string;
    isApproved: boolean | null;
    isGuest: boolean;
    isSubscribed: boolean | null;
    lastLoginOn: Date | null;
    lastName: string;
    password: string;
    requiresActivation: boolean | null;
    role: string;
    roleTranslated: string;
    setDefaultCustomer: boolean;
    shipToId: string | null;
    userName: string;
    vmiRole: string;
    vmiRoleTranslated: string;
}

type HandlerType = ApiHandlerDiscreteParameter<
    { accountId: string } & HasOnSuccess,
    StoreGetAccountApiParameter,
    AccountModel
>;
export const API_URL_CURRENT_FRAGMENT = "current";

export interface ApiParameter {
    additionalQueryStringParameters?: Dictionary<any>;
}

function cleanAccount(
    accountModel: StoreAccountModel,
    parameter?: { expand?: string[]; additionalExpands?: string[] },
) {
    accountModel.lastLoginOn = accountModel.lastLoginOn && new Date(accountModel.lastLoginOn);
    if (doesNotHaveExpand(parameter, "roles")) {
        delete accountModel.availableRoles;
    }

    if (doesNotHaveExpand(parameter, "approvers")) {
        delete accountModel.availableApprovers;
    }
}

export async function administrationGetAccount(parameter: StoreGetAccountApiParameter) {
    parameter.expand?.push("administration");
    parameter.expand?.push("approvers");
    parameter.expand?.push("roles");
    const accountsUrl = "/api/v1/accounts";
    const accountId = parameter.accountId || API_URL_CURRENT_FRAGMENT;
    const account = await get<AccountModel>(`${accountsUrl}/${accountId}`, {
        expand: parameter.expand,
    } as ApiParameter);
    cleanAccount(account, parameter);
    return account;
}

export const AdministrationRequestDataFromApi: HandlerType = async props => {
    props.apiResult = await administrationGetAccount(props.apiParameter);
};

replaceInChain(chain, RequestDataFromApi, AdministrationRequestDataFromApi);
